import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'ngx-form-list-checkbox-renderer',
  template: '<input type="checkbox" (click)="changeBoolean()" [checked]="this.checked">',
})
export class FormListCheckboxRendererComponent implements ViewCell, OnInit {

  @Input() value: any;
  @Input() rowData: any;

  checked: boolean;

  constructor() { }

  ngOnInit() {
    this.checked = this.value;
  }

  changeBoolean() {
    this.checked = !this.checked;
  }

}
